import "@/App.css";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import CookieConsent from "@/components/CookieConsent";
import SiteGate from "@/components/SiteGate";

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <div className="App">
          <SiteGate>
            <Home />
            <CookieConsent />
          </SiteGate>
          <Toaster position="bottom-right" theme="system" richColors closeButton />
        </div>
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
